import useBundle from "hooks/useBundle";

const useScenarioSessionId = () => {
  const { data } = useBundle();

  return data?.sessionId;
};

export default useScenarioSessionId;
